var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordpressHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 9.17188,
    x2: 42.1337,
    y1: 35.0286,
    y2: 0.264363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m22 10c-6.619 0-12 5.381-12 12s5.381 12 12 12 12-5.386 12-12c0-6.619-5.381-12-12-12zm0 1.2c5.953 0 10.8 4.842 10.8 10.8s-4.847 10.8-10.8 10.8-10.8-4.847-10.8-10.8c0-5.958 4.847-10.8 10.8-10.8zm0 1.2c-1.5906-.004-3.1571.3883-4.5581 1.1412-1.4011.753-2.5926 1.8431-3.4669 3.1718.225.009.46.037.637.037 1.004 0 2.55-.15 2.55-.15.516-.028.554.764.038.825 0 0-.51.042-1.088.075l3.188 9.525 2.1-6.3-1.162-3.225c-.516-.028-1.013-.075-1.013-.075-.52-.033-.478-.858.037-.825 0 0 1.608.15 2.55.15 1.004 0 2.55-.15 2.55-.15.52-.028.591.764.075.825 0 0-.548.042-1.124.075l3.487 9.6.975-3.188c.314-1.28.713-2.287.713-3.112 0-.9-.413-1.317-.788-1.95-.473-.797-.938-1.458-.938-2.25 0-.881.67-1.688 1.613-1.688.042 0 .07-.004.113 0-1.7711-1.6214-4.0868-2.518-6.488-2.512zm8.438 4.988c.042.304.018.618.037.975.047.975-.145 2.475-.375 3.187-.731 2.264-2.888 8.475-2.888 8.475.038-.014.108-.042.263-.15 1.2774-.877 2.321-2.053 3.0399-3.4255.719-1.3726 1.0915-2.9001 1.0851-4.4495.0067-1.6107-.3933-3.1971-1.163-4.612zm-17.214.712c-.5456 1.2277-.8264 2.5565-.824 3.9-.0015 1.7999.5043 3.5637 1.4594 5.0892.9551 1.5256 2.3209 2.751 3.9406 3.5358l-4.575-12.525zm8.963 4.725-2.888 8.4c.8773.254 1.7867.3803 2.7.375 1.116 0 2.19-.173 3.188-.525-.0278-.0486-.0528-.0986-.075-.15z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressHosting);
export default __webpack_public_path__ + "static/media/wordpress-hosting.8bbc9341dec07150df38787290df9b22.svg";
export { ForwardRef as ReactComponent };